







import { Component } from 'vue-property-decorator'
import LayoutFooter from '@/category/LayoutFooter'
import _ from 'lodash'

@Component
export default class extends LayoutFooter {
	copyright = null

	$env: any
	mounted() {
		this.getCopyRight()
	}

	private async getCopyRight() {
		try {
			let result = await this.$http.get('api/SystemSetting/GetCopyRight')
			this.copyright = result.data
		} catch {
			this.copyright = _.isEmpty(this.$env.COPYRIGHT) ? 'Copyright © 2020 WisdomGarden' : this.$env.COPYRIGHT
		}
	}
}
